<div class="maximize-map-with-sidebar-button">
    <ui-map-button>
        <ui-icon
            aria-hidden
            [icon]="'window-maximize'"
        />
    </ui-map-button>
</div>
